import { soFetch } from 'so-fetch';
import * as constants from './partnerFinder-constants.js';
import checkStatus from '../../utils/checkStatus.js';
// import * as queries from './partnerFinder-graphql-query';

const credentialsAndHeaders = {
  credentials: 'same-origin',
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
};

const put = Object.assign({ method: 'put' }, credentialsAndHeaders);

export const closePopover = () => ({ type: constants.CLOSE_PF_CUSTOM_MSG_POPOVER });
export const openPopover = payload => ({ type: constants.OPEN_PF_CUSTOM_MSG_POPOVER, payload });
export const updateCustomizedMsg = payload => ({ type: constants.UPDATE_CUSTOM_MSG, payload });

export function connectionResponseTime(companyId) {
  return dispatch => {
    dispatch({ type: constants.GETTING_RESPONSE_TIME });
    return fetch(`/proxy/connections/${companyId}/responseTime`, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
    .then(checkStatus)
    .then(res => res.json())
    .then(response => dispatch({ type: constants.GOT_RESPONSE_TIME, payload: { companyId, response } }));
  };
}

export function search(params, pagination, noCount) {
  return dispatch => {
    let qs = params;
    dispatch({ type: constants.MODIFY_PARAMS, params });
    if (!noCount && !pagination) {
      qs = {
        ...params,
        log: true,
      };
      dispatch({ type: constants.ADD_SEARCH_COUNT });
    }
    if (!pagination) dispatch({ type: constants.SEARCH_STARTING });
    return (soFetch('/proxy/partnerfinder', {
      qs,
      method: 'get',
      actionType: constants.SEARCH,
    })(dispatch)).catch(err => dispatch({ type: constants.SEARCH_FAILED, err }));
  };
}

export function searchCountOnly(params) {
  return dispatch => {
    const qs = Object.assign({}, params, { log: false });
    dispatch({ type: constants.MODIFY_PARAMS, params });
    dispatch({ type: constants.SEARCH_STARTING });
    return (soFetch('/proxy/partnerfinder', {
      qs,
      method: 'get',
      actionType: constants.SEARCH_COUNT_ONLY,
    })(dispatch)).catch(err => dispatch({ type: constants.SEARCH_FAILED, err }));
  };
}

export const flipLoaderstatus = payload => ({ type: constants.FLIP_LOADER_STATUS, payload });

export function sendInvitation(customMsg, { companyId, locationId, productId }) {
  return dispatch => {
    dispatch(closePopover());
    dispatch(flipLoaderstatus({ companyId }));
    return fetch(`/proxy/connections/${companyId}`, {
      method: 'post',
      body: JSON.stringify({ customMsg }),
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    }).then(res => {
      if (res.status !== 200) throw new Error(res.status);
      return res.json();
    }).then(res => {
      return dispatch({
        connectionId: res._id,
        companyId,
        locationId,
        productId,
        type: constants.SEND_INVITATION_PF,
        payload: res,
      });
    }).catch(err => {
      console.log('sendInvitation error: ', err);
      dispatch(flipLoaderstatus({ companyId }));
      throw new Error(err);
    });
  };
}

export function resendInvitation(connectionId, companyId, locationId, productId) {
  return dispatch => {
    dispatch(flipLoaderstatus({ connectionId }));
    return fetch(`/proxy/connections/${connectionId}/resend`, put)
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      return res.json();
    }).then(res => {
      return dispatch({
        companyId,
        locationId,
        productId,
        connectionId,
        type: constants.RESEND_INVITATION_PF,
        payload: res,
      });
    })
    .catch(err => {
      console.log('resendInvitation error: ', err);
      dispatch(flipLoaderstatus({ connectionId }));
      throw new Error(err);
    });
  };
}

export function fakeResendInvitation(connectionId, companyId, locationId, productId) {
  return dispatch => {
    dispatch(flipLoaderstatus({ connectionId }));

    return fetch(`/proxy/connections/${connectionId}/fakeResend`, put)
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      else return res.json();
    }).then(res => {
      return dispatch({
        connectionId,
        companyId,
        locationId,
        productId,
        type: constants.FAKE_RESEND,
        payload: res,
      });
    })
    .catch(err => {
      console.log('fResendInvitation error: ', err);
      dispatch(flipLoaderstatus({ connectionId }));
      throw new Error(err);
    });
  };
}

export function acceptConnection(connectionId, companyId, locationId, productId) {
  return dispatch => {
    dispatch(flipLoaderstatus({ connectionId }));

    return fetch(`/proxy/connections/${connectionId}/accepted`, put)
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      else return res.json();
    }).then(res => {
      return dispatch({
        connectionId,
        companyId,
        locationId,
        productId,
        type: constants.ACCEPT_CONNECTION_PF,
        payload: res,
      });
    })
    .catch(err => {
      console.log('acceptConnection error', err);
      dispatch(flipLoaderstatus({ connectionId }));
      throw new Error(err);
    });
  };
}

export function ignoreConnection(connectionId, companyId, locationId, productId) {
  return dispatch => {
    dispatch(flipLoaderstatus({ connectionId }));
    return fetch(`/proxy/connections/${connectionId}/rejected`, put)
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      return res.json();
    }).then(res => {
      return dispatch({
        connectionId,
        companyId,
        locationId,
        productId,
        type: constants.IGNORE_CONNECTION_PF,
        payload: res,
      });
    })
    .catch(err => {
      console.log('ignoreConnection', err);
      dispatch(flipLoaderstatus({ connectionId }));
      throw new Error(err);
    });
  };
}

// FOR ADDING MM TO PF
// export function getMarketingMaterials(companyId, locationId) {
//   return dispatch => {
//     dispatch({ type: constants.GETTING_MARKETING_MATERIALS });
//     return fetch(`/proxy/company/${companyId}?query=${queries.MMQuery}`, {
//       method: 'get',
//       credentials: 'same-origin',
//       headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
//     })
//     .then(res => res.json())
//     .then(response => dispatch({ type: constants.GOT_MARKETING_MATERIALS, payload: {
//       companyId,
//       media: response.media,
//       locationId,
//     } }));
//   };
// }



// WEBPACK FOOTER //
// ./src/app/stores/partner-finder/partnerFinder-actions.js